<template>
  <div>
    <NavigationBar
      titel="Frist bearbeiten"
      showBackBtn
      :actions="actions"
    ></NavigationBar>
    <section>
      <v-form
        @submit.prevent="updateItem"
        ref="form"
        v-model="helpers.formIsValid"
      >
        <deadline-editor v-model="deadline" mode="edit"></deadline-editor>
      </v-form>
    </section>
  </div>
</template>

<script>
import { db } from "@/firebase";
import { MEMBER_MANAGEMENT } from "@/store/modules.js";
import { UPDATE_DEADLINE } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import DeadlineEditor from "@/components/member-management/deadlines/DeadlineEditor.vue";

export default {
  name: "member-management-deadline-edit",
  components: {
    NavigationBar,
    DeadlineEditor,
  },
  data() {
    return {
      actions: [
        {
          title: "Speichern",
          icon: "mdi-content-save",
          actionStyle: "textBtnSubmit",
          function: this.updateItem,
        },
      ],
      deadline: null,

      helpers: {
        formIsValid: false,
      },
    };
  },
  computed: {},
  created() {
    this.initialize();
  },
  watch: {
    $route: "initialize",
  },
  methods: {
    initialize() {
      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("deadlines")
        .doc(this.$route.params.itemId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.deadline = doc.data();
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },
    validate() {
      this.$refs.form.validate();
    },
    updateItem() {
      this.validate();

      if (this.helpers.formIsValid) {
        this.$store.dispatch(`${MEMBER_MANAGEMENT}${UPDATE_DEADLINE}`, {
          organizationId: this.$route.params.organizationId,
          itemId: this.$route.params.itemId,

          title: this.deadline.title,
          shortTitle: this.deadline.shortTitle,
          sortKey: this.deadline.sortKey,
          description: this.deadline.description,
          availableLabels: this.deadline.availableLabels,
          applicableTo: {
            divisionIds: this.deadline.applicableTo.divisionIds,
            userGroupIds: this.deadline.applicableTo.userGroupIds,
          },
          dueType: this.deadline.dueType,
          defaultInterval: {
            value: this.deadline.defaultInterval.value,
            unit: this.deadline.defaultInterval.unit,
          },
          reminderInterval: {
            value: this.deadline.reminderInterval.value,
          },
          watchers: this.deadline.watchers,
          updatePolicy: this.deadline.updatePolicy,
          renewalPolicy: this.deadline.renewalPolicy,
          proofPolicy: this.deadline.proofPolicy,
          proofHintText: this.deadline.proofHintText,
          approvalProcess: this.deadline.approvalProcess,
        });
      } else {
        alert("Prüfe Deine Eingabe und versuche es erneut.");
      }
    },
  },
};
</script>
